<template>
  <div class="app-wrapper">
    <div id="app"
      :class="$route.name"
    >
      <transition name="page">
        <router-view
          v-if="!usePortrait"
          :bg-image="`${publicPath}/img/landscape-4032192_1920.jpg`"
        />
      </transition>
      <transition name="page">
        <UsePortraitScreen
          class="view" v-if="usePortrait"
        ></UsePortraitScreen>
      </transition>
    </div>
  </div>
</template>

<script>
import 'browser-report'
import Vue from 'vue'
import AuthService from 'Core/src/auth/authService'

Vue.use(AuthService)
Vue.prototype.$eventHub = new Vue()

export default {
  name: 'app',

  data () {
    return {
      usePortrait: false,
      publicPath: process.env.VUE_APP_BASE_URL
    }
  },

  computed: {
    routeName () {
      return this.$route.name
    }
  },

  components: {
    UsePortraitScreen: () => import('Components/base/UsePortraitScreen')
  },

  mounted () {
    // We store the redirect_to_url var in localStorage
    var redirectTo = localStorage.getItem('redirect_to_url')
    if (redirectTo) { // ensure that no redirect happens if it's the same URL (home)
      localStorage.removeItem('redirect_to_url')
      setTimeout(() => {
        this.canRender = true
      }, 500)
      this.$router.push(redirectTo)
    } else {
      this.canRender = true
    }

    /*
     * Add a browser report. TODO: check if there's a better package that works with the Brave browser.
     */
    // eslint-disable-next-line
    browserReport((err, report) => {
      if (err) {
        throw err
      }
      this.$store.commit('BROWSER_REPORT', { report: report })
    })
  },
  watch: {
    'qid': function (newVal) {
      this.$store.commit('SET_ACTUAL_QID', { qid: parseInt(newVal, 10) })
      this.$store.commit('SET_CURRENT', { current: parseInt(newVal, 10) })
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
  background-size: cover;
  background-position: center center;
  min-width: 100vw;

  &.not-found {
    background-color: #F5F4F0;
    height: 100vh;
    display: flex;
  }
}

.app-wrapper {
  min-height: 100vh;
}

</style>
